<div class="container-ld {{ class }}">
  <div class="d-flex flex-column align-items-center">
    <h1 lang class="title">not-found.title</h1>
    <h2 lang>not-found.subtitle</h2>
    <hs-recent-articles></hs-recent-articles>
  </div>
</div>